import React from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom'
import Home from './components/home/Home.js'
import NavBar from './components/nav/NavBar.js'
import AppFooter from './components/AppFooter.js'
import Schedule from './components/schedule/Schedule.js'
import Appointments from './components/appointments/Appointments.js'
import NotFound from './components/NotFound.js'

function App() {
  return (
    <BrowserRouter basename="/salon-app/">
      <NavBar />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/schedule" component={Schedule} />
        <Route path="/appointments" component={Appointments} />
        <Route component={NotFound} />
      </Switch>
      <AppFooter />
    </BrowserRouter>
  );
}

export default App;
